/*
 * Controls the behaviour of the modal window
 * (Legal copy)
 * 
 * @author eric.bailey@barrelny.com
 *
 */

var Legal = {
	init: function(){
		$show = $('.js-legalModalShow'),
		$hide = $('.js-legalModalHide'),
		$modal = $('#LegalModal');

		$show.on('click', function(){
			Legal.show($modal);
		});
		$hide.on('click', function(){
			Legal.hide($modal);
		});
	},
	show: function(el){
		el.show().animate({opacity: 1}, 400);
		$('body').addClass('overflow-hidden');
	},
	hide: function(el){
		el.animate({opacity: 0}, 400, function(){
			$(this).hide();
			$('body').removeClass('overflow-hidden');
		});
	}
}

module.exports = Legal;